import axios from 'axios';

const apiAuth = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    // auth: 'Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJhcHB6dGVjYXMiLCJleHAiOjE3NTY1MjYxODcsImlhdCI6MTc1NDEwNjk4NywiaXNzIjoiYXBwenRlY2FzIiwianRpIjoiZTdiNmRhYzQtOTE2OS00NmNiLWIyMDQtZDUzMTViYjEwZWJiIiwibmJmIjoxNzU0MTA2OTg2LCJzdWIiOiJiZTEyYmU0ZC00ZmMzLTQxODctOTk3Zi03NDQ2ZGRmOGUwY2VfYWRtaW4iLCJ0eXAiOiJhY2Nlc3MifQ.rpQF-bBvzB6GH6CSdg6o5AlIY9XVDsLHEwwL258fhXwzkz4N2peo2GzeryW3yd5twVaTyB7cAMU1GGeIVysNNA'
});

export const Interceptor = (store: any) => {
    /**
     * Request interceptor
     */
    apiAuth.interceptors.request.use((request: any) => {
        // TODO: Enable when token are added
        // const { data } = store.getState().user;
        // if ( useToken && data.token && request.headers)
        //   request.headers.Authorization = `Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJhcHB6dGVjYXMiLCJleHAiOjE3NTY4MzQ0MDUsImlhdCI6MTc1NDQxNTIwNSwiaXNzIjoiYXBwenRlY2FzIiwianRpIjoiMGFiZGRmZTgtZjFlZC00OTI0LTgyOWItNTZhNzZjOTg0NjA2IiwibmJmIjoxNzU0NDE1MjA0LCJzdWIiOiJiZTEyYmU0ZC00ZmMzLTQxODctOTk3Zi03NDQ2ZGRmOGUwY2VfYWRtaW4iLCJ0eXAiOiJhY2Nlc3MifQ.rsA4kOKAWFwkrMWvtBacwgRDiRoik5dW64ahl5Bg1RcrmLwqpcfQaidEwkkm_9sFLCbGOOgSgATtLGe24uVf_Q`;
        return request;
    });

    /**
     * Response interceptor
     */
    apiAuth.interceptors.response.use((response) => response);
}

export const returningError = (error:any) => {
    if (error?.response) {
        const err = typeof(error?.response?.data) !== 'object' ?
            error?.response?.data
            :
            error?.response?.data?.errors[0] || JSON.stringify(error?.response?.data?.errors).replaceAll(/[{}]|\]|\[|"|status|/gi, '');
        return {
            data: '',
            errors: err,
            status: error?.response?.status,
            success: 'false'
        };
    }
    return {
        data: '',
        errors: error.message,
        status: 500,
        success: 'false'
    };
}

export default apiAuth;